module.exports = __webpack_public_path__ + "static/media/icon Language -brown 794D4F.64e34f2b.svg";